import { render } from "./EditP2POffer.vue?vue&type=template&id=07d69ecb&scoped=true"
import script from "./EditP2POffer.vue?vue&type=script&lang=js"
export * from "./EditP2POffer.vue?vue&type=script&lang=js"

import "./EditP2POffer.vue?vue&type=style&index=0&id=07d69ecb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d69ecb"]])

export default __exports__